<template>
    <div class="cxbox">
        <HeaderNav
            header-title="产销概况"
            left-icon-name="2"
            right-icon-name="2"
            @change-org="getNewOrgId"
        ></HeaderNav>

        <monthSelectTitle :tit="title" @change-month="changeMonth"></monthSelectTitle>
        <!-- 弹出日历控件 -->
        <div
            class="picker-content"
            v-show="showPickerTime"
        >
            <van-datetime-picker
                v-model="currentDate"
                :max-date="maxDate"
                type="year-month"
                @confirm="selectTime"
                @cancel="showPickerTime = false"
            ></van-datetime-picker>
        </div>
        <div class="marketing-box">
            <div class="concrete">
                <h1>混凝土</h1>
                <div class="concrete-box">
                    <div class="table-one">
                        <p>年度计划完成率</p>

                        <div class="circle">
                            <div class="pie_left">
                                <div class="left" ref="pieLeft"></div>
                            </div>

                            <div class="pie_right">
                                <div class="right" ref="pieRight"></div>
                            </div>
                            <div class="mask">
                                {{ mask }}%
                            </div>
                        </div>


                        <h2 class="blues-color">
                            {{ getSalesInfoData.concrete_year_sales | toFixedNumber }}
                        </h2>
                        <span>累计销量(万方)</span>
                        <h2 class="reds-color">
                            {{ getSalesInfoData.concrete_year_sales_plan | toFixedNumber }}
                        </h2>
                        <span>计划销量(万方)</span>
                    </div>
                    <div class="table-two">
                        <div class="heng-one">
                            <dl>
                                <dd>本年销量(万方)</dd>
                                <dd class="teshu-color origin-color">
                                    {{ getSalesInfoData.concrete_year_sales | toFixedNumber }}
                                </dd>
                            </dl>
                            <dl>
                                <dd>售价(元/方)</dd>
                                <dd class="teshu-color qing-color">
                                    {{ getSalesInfoData.concrete_year_price | toFixedNumber }}
                                </dd>
                            </dl>
                            <dl>
                                <dd>成本(元/方)</dd>
                                <dd class="teshu-color red-color">
                                    {{ getSalesInfoData.concrete_year_cost | toFixedNumber }}
                                </dd>
                            </dl>
                            <dl>
                                <dd>毛利率(%)</dd>
                                <dd class="teshu-color blue-color">
                                    {{ getSalesInfoData.concrete_year_gross_rate | toFixedNumber }}
                                </dd>
                            </dl>
                        </div>
                        <div class="heng-one">
                            <dl>
                                <dd>本月销量(万方)</dd>
                                <dd class="teshu-color origin-color">
                                    {{ getSalesInfoData.concrete_month_sales | toFixedNumber }}
                                </dd>
                            </dl>
                            <dl>
                                <dd>售价(元/方)</dd>
                                <dd class="teshu-color qing-color">
                                    {{ getSalesInfoData.concrete_month_price | toFixedNumber }}
                                </dd>
                            </dl>
                            <dl>
                                <dd>成本(元/方)</dd>
                                <dd class="teshu-color red-color">
                                    {{ getSalesInfoData.concrete_month_cost | toFixedNumber }}
                                </dd>
                            </dl>
                            <dl>
                                <dd>毛利率(%)</dd>
                                <dd class="teshu-color blue-color">
                                    {{ getSalesInfoData.concrete_month_gross_rate | toFixedNumber }}
                                </dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </div>
            <div class="concrete concrete-mortar">
                <h1>砂浆</h1>
                <div class="concrete-box">
                    <div class="table-one">
                        <p>年度计划完成率</p>

                        <div class="circle circleTwo">
                            <div class="pie_left">
                                <div class="left" ref="pieLeftTwo"></div>
                            </div>

                            <div class="pie_right">
                                <div class="right" ref="pieRightTwo"></div>
                            </div>
                            <div class="mask">
                                {{ yuanTwo }}%
                            </div>
                        </div>


                        <h2>{{ getSalesInfoData.mortar_year_sales | toFixedNumber }}</h2>
                        <span>累计销量(万方)</span>
                        <h2 class="reds-color">
                            {{ getSalesInfoData.mortar_year_sales_plan | toFixedNumber }}
                        </h2>
                        <span>计划销量(万方)</span>
                    </div>
                    <div class="table-two">
                        <div class="heng-one">
                            <dl>
                                <dd>本年销量(万方)</dd>
                                <dd class="teshu-color origin-color">
                                    {{ getSalesInfoData.mortar_year_sales | toFixedNumber }}
                                </dd>
                            </dl>
                            <dl>
                                <dd>售价(元/方)</dd>
                                <dd class="teshu-color qing-color">
                                    {{ getSalesInfoData.mortar_year_price | toFixedNumber }}
                                </dd>
                            </dl>
                            <dl>
                                <dd>成本(元/方)</dd>
                                <dd class="teshu-color red-color">
                                    {{ getSalesInfoData.mortar_year_cost | toFixedNumber }}
                                </dd>
                            </dl>
                            <dl>
                                <dd>毛利率(%)</dd>
                                <dd class="teshu-color blue-color">
                                    {{ getSalesInfoData.mortar_year_gross_rate | toFixedNumber }}
                                </dd>
                            </dl>
                        </div>
                        <div class="heng-one">
                            <dl>
                                <dd>本月销量(万方)</dd>
                                <dd class="teshu-color origin-color">
                                    {{ getSalesInfoData.mortar_month_sales | toFixedNumber }}
                                </dd>
                            </dl>
                            <dl>
                                <dd>售价(元/方)</dd>
                                <dd class="teshu-color qing-color">
                                    {{ getSalesInfoData.mortar_month_price | toFixedNumber }}
                                </dd>
                            </dl>
                            <dl>
                                <dd>售价(元/方)</dd>
                                <dd class="teshu-color red-color">
                                    {{ getSalesInfoData.mortar_month_cost | toFixedNumber }}
                                </dd>
                            </dl>
                            <dl>
                                <dd>毛利率(%)</dd>
                                <dd class="teshu-color blue-color">
                                    {{ getSalesInfoData.mortar_month_gross_rate | toFixedNumber }}
                                </dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom-btn">
                <van-button type="info" @click="toLink('structure')">
                    按结构
                </van-button>
                <van-button type="info" @click="toLink('byTrend')">
                    按趋势
                </van-button>
            </div>
        </div>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
import { Dialog } from 'vant';
import utils from '@/assets/js/utils';
import monthSelectTitle from '@/components/header-nav/monthSelectTitle';
export default {
    data() {
        return {
            mask: 0,
            yuanTwo: 0,
            showPickerTime: false,
            orgId: '',
            currentDate: new Date(),
            maxDate: '',
            selectTimeYear: '',
            selectTimeMonth: '',
            getSalesInfoData: {},
            title: '',
        };
    },
    components: {
        HeaderNav,
        monthSelectTitle,
    },
    created() {
        const obj = utils.getPreMon();
        this.maxDate = new Date(obj.year, obj.month - 1, obj.lastDate);
    },
    mounted() {
        this.$nextTick(() => {
            const objTimeYear = localStorage.getItem('objTimeYear');
            const objTimeMonth = localStorage.getItem('objTimeMonth');
            this.selectTimeYear = objTimeYear || this.$route.query.year;
            this.selectTimeMonth = objTimeMonth || this.$route.query.month;
            const value = this.$store.state.orgData[0].value;
            this.title = this.selectTimeYear + '年' + this.selectTimeMonth + '月份，中国联合水泥商混业务产销概况';
            this.orgId = value;
            this.getSalesInfo();
        });
    },
    methods: {

        // 按月下来筛选
        changeMonth() {
            this.showPickerTime = true;
        },
        toLink(link) {
            this.$router.isBack = 2;
            this.$router.push({
                name: link,
                query: {
                    year: this.selectTimeYear,
                    month: this.selectTimeMonth,
                    orgId: this.orgId,
                },
            });
        },
        getNewOrgId(value) {
            this.orgId = value;
            this.getSalesInfo();
        },
        // 获取销售概况
        getSalesInfo() {
            this.$axios
                .get(`/interfaceApi/report/SaleManager/get_sales_info/${this.selectTimeYear}/${this.selectTimeMonth}/${this.orgId}`)
                // .get(`/interfaceApi/report/SaleManager/get_sales_info/2019/${this.selectTimeMonth}/OT000001`)
                .then(res => {
                    if (res) {
                        this.getSalesInfoData = res;
                        if (res.concrete_year_sales_rate) {
                            this.mask = Number(res.concrete_year_sales_rate.toFixed(2));
                        } else {
                            this.mask = 0;
                        }
                        if (res.mortar_year_sales_rate) {
                            this.yuanTwo = Number(res.mortar_year_sales_rate.toFixed(2));
                        } else {
                            this.yuanTwo = 0;
                        }
                        setTimeout(() => {
                            this.crilHandle();
                            this.crilHandleTwo();
                        });
                    }
                })
                .catch(error => {
                    Dialog({ message: error.Errorcode.Message });
                });
        },
        // 格式化日期
        timeFormat(date, status, upMonth) {
            const y = date.getFullYear(); // 年
            let m = date.getMonth() + 1; // 月
            let d = date.getDate(); // 日
            m = m > 9 ? m : '0' + m;
            d = d > 9 ? d : '0' + d;
            if (status === 'year') {
                return y;
            } if (status === 'month') {
                if (upMonth === 'upMonth') {
                    return m - 1;
                }
                return m;

            } if (status === 'day') {
                return d;
            }
            return `${y}-${m}-${d}`;
        },
        // 时间选择
        selectTime(value) {
            this.selectTimeYear = this.timeFormat(value, 'year');
            this.selectTimeMonth = this.timeFormat(value, 'month');
            this.title = this.selectTimeYear + '年' + this.selectTimeMonth + '月份，中国联合水泥商混业务产销概况';
            this.getSalesInfo();
            this.showPickerTime = false;
        },
        // 进度条
        crilHandle() {
            let num = this.mask * 3.6;
            this.$refs.pieLeft.style.transform = 'rotate(0deg)';
            if (num > 360) {
                num = 360;
            }
            if (num <= 180) {
                this.$refs.pieRight.style.transform = 'rotate(' + num + 'deg)';
            } else {
                this.$refs.pieRight.style.transform = 'rotate(180deg)';
                this.$refs.pieLeft.style.transform = 'rotate(' + (num - 180) + 'deg)';
            }
        },
        crilHandleTwo() {
            this.$refs.pieLeftTwo.style.transform = 'rotate(0deg)';
            let num = this.yuanTwo * 3.6;
            if (num > 360) {
                num = 360;
            }
            if (num <= 180) {
                this.$refs.pieRightTwo.style.transform = 'rotate(' + num + 'deg)';
            } else {
                this.$refs.pieRightTwo.style.transform = 'rotate(180deg)';
                this.$refs.pieLeftTwo.style.transform = 'rotate(' + (num - 180) + 'deg)';
            }
        },
    },
};

</script>
<style lang='stylus' scoped>
.cxbox
    padding-top 74rpx
    height calc(100% - 74rpx)
.marketing-box
    overflow-y scroll
    height 100%
.picker-content
    position fixed
    width: 100%;
    z-index 9
    height: 100%;
    background: rgba(0, 0, 0, .4);
    top: 0
    z-index 999
.van-picker
    position: fixed;
    bottom: 0;
    width: 100%;
.title-tips
    width 100%
    height 30rpx
    font-size 12rpx
    color #333333
    display flex
    justify-content center
    align-items center
    background #F0F0F0
    margin-top: 44rpx;
    .iconrili
        font-size 18rpx
        margin-right 6rpx
        cursor pointer
        color: #5588F1;
.concrete
    h1
        color #333333
        padding 15rpx 15rpx;
        font-size 16rpx
.concrete-box
    display flex
    padding-left 15rpx
    padding-bottom 15rpx
    border-bottom 15rpx solid #F0F0F0
    .table-one
        width 112rpx
        height 220rpx
        border:1px solid rgba(240, 240, 240, 1);
        box-shadow: 2rpx 2rpx 3rpx 2rpx #D6E6F5;
        border-radius:4rpx;
        display flex
        flex-direction column
        align-items center
        .blues-color
            color #5588F1
        .reds-color
            color #EB656F
        p
            font-size 10rpx
            color #666666
            margin-top 15rpx
            font-weight 800
        h2
            font-size 16rpx
            font-weight 800
            color #FA8436
        span
            font-size 9rpx
            color #979EA7
    .table-two
        width 220rpx
        height 220rpx
        margin-left 15rpx
        .heng-one
            box-shadow: 4px 4px 3px 4px #D6E6F5;
            display flex
            flex-wrap wrap
            height 100rpx
            border-radius: 4rpx;
            border 1px solid #f0f0f0
            &:last-child
                margin-top 20rpx
            dl
                width 50%
                display flex
                flex-direction column
                justify-content center;
                align-items center
                border 1px dashed #f0f0f0;
                &:nth-child(1)
                    border-top none
                    border-left none
                    border-right none
                &:nth-child(2)
                    border-top none
                    border-right none
                &:nth-child(3)
                    border none
                &:nth-child(4)
                    border-top none
                    border-right none
                    border-bottom none
                dd:first-child
                    color #666666
                    font-size 10rpx
                    font-weight 700
                .teshu-color
                    font-size 14rpx
                    margin-top 7rpx
                .origin-color
                    color #FA8436
                .qing-color
                    color #21BDCC
                .red-color
                    color #EB656F
                .blue-color
                    color #5588F1

.concrete-mortar .concrete-box
    border-bottom none !important
    margin-bottom 15rpx
.bottom-btn
    display flex
    justify-content center
    align-items center
    padding-bottom 15rpx
    .van-button--info
        border none
    button:first-child
        background #5588F1
    button:last-child
        background #EB656F
        margin-left 15rpx
.circle
    width: 60rpx;
    height: 60rpx;
    position: relative;
    border-radius: 50%;
    margin 20rpx 0
    background #5588F1
    .pie_left, .pie_right
        width:60rpx;
        height:60rpx;
        position: absolute;
        top: 0;left: 0;
    .left, .right
        width:60rpx;
        height:60rpx;
        background:#00aacc;
        border-radius: 50%;
        position: absolute;
        background #F1F4FF
        top: 0;
        left: 0;
    .pie_right, .right
        clip: rect(0,auto,auto, 30rpx);
    .pie_left, .left
        clip: rect(0, 30rpx,auto,0);
    .mask
        width: 50rpx;
        height: 50rpx;
        display flex
        justify-content center
        align-items center
        border-radius: 50%;
        position: absolute;
        background: #FFF;
        left: 5rpx;
        top: 5rpx;
        text-align: center;
        // line-height: 50rpx;
        color #5588F1
        font-size 12rpx
        font-weight 800
.circleTwo
    background #FA8436
    .left, .right
        background #FEF3F0
    .mask
        color #FA8436
</style>